import { ApiUrl } from "./Domains";
import { AuthService } from "./Services/AuthService";
import { useParams } from "react-router-dom";
import { AuthStorage } from "utils/auth-storage";

export class Network {
  constructor() {
    this.bearer = "";
  }

  static async fetch(url, init, addAuth) {
    let requestedUrl = ApiUrl + url;

    const response = await fetch(requestedUrl, {
      mode: "cors",
      ...init,
      headers: Network.getHeaders(init.headers, addAuth),
    });

    let lastRequestTime = AuthStorage.getItem("lastRequestTime");
    let token = AuthStorage.getItem("token");
    const isRefresh = url.includes("refreshToken");

    let currentTime = new Date().getTime();
    if (lastRequestTime && currentTime - lastRequestTime < 3600000) {
      // Token exists and last request was made within the last hour, do nothing
    } else if (token) {
      if (
        (response.status === 401 && !isRefresh) ||
        (response.status === 400 && !isRefresh) ||
        (response.status === 405 && !isRefresh)
      ) {
        let code = token;
        let loginEmail = AuthStorage.getItem("email");
        let refreshCode = AuthStorage.getItem("refreshToken");
        let company_id = AuthStorage.getItem("company_id");
        let data = {
          loginEmail,
          access_token: code,
          refresh_token: refreshCode,
          company_id,
        };
        AuthService.refreshToken(data)
          .then((res) => {
            AuthStorage.setItem("token", res.access_token);
            AuthStorage.setItem("refreshToken", res.refresh_token);
            AuthStorage.setItem("lastRequestTime", new Date().getTime());

            window.location.reload();
          })
          .catch((err) => {
            console.log(err);
            AuthStorage.clearAll();
            window.location.assign("/");
          });
      }
    } else {
      // Token doesn't exist in local storage, do nothing
    }

    let promise;
    if (![200, 201, 204].includes(response.status)) {
      promise = response.json().then((data) => {
        return Promise.reject(data);
      });
      return promise.catch((error) => Promise.reject(error));
    } else if (response.status === 204) {
      promise = Promise.resolve({});
    } else {
      // only parse JSON if body is not empty
      const text = await response.text();
      promise = text ? JSON.parse(text) : {};
    }

    return promise;
  }

  static async fetchBlob(url, init, addAuth) {
    let requestedUrl = ApiUrl + url;

    const response = await fetch(requestedUrl, {
      mode: "cors",
      ...init,
      headers: Network.getHeaders(init?.headers, addAuth),
    });

    if (![200, 201].includes(response.status)) {
      let error = await response.text();
      return Promise.reject(error);
    }

    const blob = await response.blob();
    return blob;
  }

  static async fetchUpload(url, init) {
    let requestedUrl = ApiUrl + url;

    console.log("fetchUpload called with:", {
      url,
      requestedUrl,
      hasCallback: !!init.onUploadProgress,
      hasSignal: !!init.signal,
    });

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      // Handle abort signal if provided
      if (init.signal) {
        // Check if already aborted
        if (init.signal.aborted) {
          reject(new DOMException("Upload cancelled", "AbortError"));
          return;
        }

        // Listen for abort event
        init.signal.addEventListener("abort", () => {
          console.log("Abort signal received, cancelling upload");
          xhr.abort();
        });
      }

      // Setup upload progress listener
      if (init.onUploadProgress) {
        console.log("Setting up progress listener");
        xhr.upload.addEventListener("progress", (event) => {
          console.log(
            "Progress event fired:",
            event.lengthComputable,
            event.loaded,
            event.total,
          );
          if (event.lengthComputable) {
            const progressData = {
              loaded: event.loaded,
              total: event.total,
              progress: (event.loaded / event.total) * 100,
            };
            console.log("Calling onUploadProgress with:", progressData);
            init.onUploadProgress(progressData);
          }
        });

        // Also listen to loadstart to ensure upload is starting
        xhr.upload.addEventListener("loadstart", () => {
          console.log("Upload started");
        });

        xhr.upload.addEventListener("loadend", () => {
          console.log("Upload ended");
        });
      } else {
        console.log("No onUploadProgress callback provided");
      }

      // Setup completion listener
      xhr.addEventListener("load", () => {
        console.log("Request completed with status:", xhr.status);
        // Create a Response-like object to match your existing code
        const response = {
          ok: xhr.status >= 200 && xhr.status < 300,
          status: xhr.status,
          statusText: xhr.statusText,
          json: async () => {
            try {
              return JSON.parse(xhr.responseText);
            } catch (e) {
              throw new Error("Invalid JSON response");
            }
          },
          text: async () => xhr.responseText,
        };

        if (!response.ok) {
          const errorText = xhr.responseText;
          reject(
            new Error(`Upload failed with status ${xhr.status}: ${errorText}`),
          );
        } else {
          resolve(response);
        }
      });

      // Setup error listener
      xhr.addEventListener("error", (e) => {
        console.error("XHR error:", e);
        reject(new Error("Network request failed"));
      });

      // Setup abort listener
      xhr.addEventListener("abort", () => {
        console.log("Request aborted");
        reject(new DOMException("Upload cancelled", "AbortError"));
      });

      // Open the request
      console.log("Opening XHR request:", init.method || "POST", requestedUrl);
      xhr.open(init.method || "POST", requestedUrl);

      // Set CORS mode if needed
      if (init.mode === "cors") {
        xhr.withCredentials = false;
      }

      // Set headers (but NOT Content-Type for FormData - browser sets it automatically with boundary)
      if (init.headers) {
        console.log("Setting headers:", init.headers);
        Object.entries(init.headers).forEach(([key, value]) => {
          // Skip Content-Type for FormData uploads
          if (key.toLowerCase() !== "content-type") {
            xhr.setRequestHeader(key, value);
          }
        });
      }

      // Send the request
      console.log("Sending request with body:", init.body);
      xhr.send(init.body);
    });
  }

  static getHeaders(originalHeaders, auth) {
    let headers = {};
    if (auth) {
      this.bearer = AuthStorage.getItem("bearer");
      headers.Authorization = `Token ${this.bearer}`;
    }
    headers = {
      ...headers,
      ...originalHeaders,
      Accept: "application/json",
      "Content-type": "application/json; charset=UTF-8",
    };

    return headers;
  }
}
